// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-viewer {
  font-family: sans-serif;
  font-size: 16px;
  overflow: hidden;
  display: block;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.cesium-viewer-cesiumWidgetContainer {
  width: 100%;
  height: 100%;
}

.cesium-viewer-bottom {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-right: 5px;
}

.cesium-viewer .cesium-widget-credits {
  display: inline;
  position: static;
  bottom: auto;
  left: auto;
  padding-right: 0;
  color: #ffffff;
  font-size: 10px;
  text-shadow: 0 0 2px #000000;
}

.cesium-viewer-timelineContainer {
  position: absolute;
  bottom: 0;
  left: 169px;
  right: 29px;
  height: 27px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  font-size: 14px;
}

.cesium-viewer-animationContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0;
  width: 169px;
  height: 112px;
}

.cesium-viewer-fullscreenContainer {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0;
  width: 29px;
  height: 29px;
  overflow: hidden;
}

.cesium-viewer-vrContainer {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0;
  width: 29px;
  height: 29px;
  overflow: hidden;
}

.cesium-viewer-toolbar {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
}

.cesium-viewer-cesiumInspectorContainer {
  display: block;
  position: absolute;
  top: 50px;
  right: 10px;
}

.cesium-viewer-geocoderContainer {
  position: relative;
  display: inline-block;
  margin: 0 3px;
}

.cesium-viewer-cesium3DTilesInspectorContainer {
  display: block;
  position: absolute;
  top: 50px;
  right: 10px;
  max-height: calc(100% - 120px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.cesium-viewer-voxelInspectorContainer {
  display: block;
  position: absolute;
  top: 50px;
  right: 10px;
  max-height: calc(100% - 120px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/Viewer/Viewer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".cesium-viewer {\n  font-family: sans-serif;\n  font-size: 16px;\n  overflow: hidden;\n  display: block;\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.cesium-viewer-cesiumWidgetContainer {\n  width: 100%;\n  height: 100%;\n}\n\n.cesium-viewer-bottom {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding-right: 5px;\n}\n\n.cesium-viewer .cesium-widget-credits {\n  display: inline;\n  position: static;\n  bottom: auto;\n  left: auto;\n  padding-right: 0;\n  color: #ffffff;\n  font-size: 10px;\n  text-shadow: 0 0 2px #000000;\n}\n\n.cesium-viewer-timelineContainer {\n  position: absolute;\n  bottom: 0;\n  left: 169px;\n  right: 29px;\n  height: 27px;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n.cesium-viewer-animationContainer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 0;\n  width: 169px;\n  height: 112px;\n}\n\n.cesium-viewer-fullscreenContainer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  width: 29px;\n  height: 29px;\n  overflow: hidden;\n}\n\n.cesium-viewer-vrContainer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  width: 29px;\n  height: 29px;\n  overflow: hidden;\n}\n\n.cesium-viewer-toolbar {\n  display: block;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n\n.cesium-viewer-cesiumInspectorContainer {\n  display: block;\n  position: absolute;\n  top: 50px;\n  right: 10px;\n}\n\n.cesium-viewer-geocoderContainer {\n  position: relative;\n  display: inline-block;\n  margin: 0 3px;\n}\n\n.cesium-viewer-cesium3DTilesInspectorContainer {\n  display: block;\n  position: absolute;\n  top: 50px;\n  right: 10px;\n  max-height: calc(100% - 120px);\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.cesium-viewer-voxelInspectorContainer {\n  display: block;\n  position: absolute;\n  top: 50px;\n  right: 10px;\n  max-height: calc(100% - 120px);\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
